import { render, staticRenderFns } from "./InsuranceData.vue?vue&type=template&id=0add07ba&scoped=true"
import script from "./InsuranceData.vue?vue&type=script&lang=js"
export * from "./InsuranceData.vue?vue&type=script&lang=js"
import style0 from "./InsuranceData.vue?vue&type=style&index=0&id=0add07ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0add07ba",
  null
  
)

export default component.exports